module.exports = __webpack_public_path__ + "static/media/photo164.a30317fb.jpg";